<!-- Header -->
<div class="dz-row header padding-vertical-object-4">
	<div class="dz-col-sm-7 dz-col-7">
		<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-sm-3 dz-col-3 text-align-right">
		<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '10px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-sm-3 dz-col-3 text-align-right">
		<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '10px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-sm-3 dz-col-3 text-align-right">
		<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '10px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-sm-3 dz-col-3 text-align-right">
		<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '10px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-sm-2 dz-col-2 text-align-right">
		<ngx-skeleton-loader [theme]="{ width: '20%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
	</div>
</div>

<!-- Rows -->
<div class="dz-row margin-top-object-6" *ngFor="let row of GHOST_ROWS">
	<div class="dz-col-sm-7 dz-col-7">
		<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px', 'margin-top': '30px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-sm-3 dz-col-3 text-align-right">
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px', 'margin-top': '30px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-sm-3 dz-col-3 text-align-right">
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px', 'margin-top': '30px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-sm-3 dz-col-3 text-align-right">
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px', 'margin-top': '30px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-sm-3 dz-col-3 text-align-right">
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px', 'margin-top': '30px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-sm-2 dz-col-2 text-align-right">
		<ngx-skeleton-loader [theme]="{ width: '20%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '20%', 'border-radius': '0', height: '25px', 'margin-top': '30px' }"></ngx-skeleton-loader>
	</div>
</div>
